import { type ModalArgs, type ModalTemplateKeys } from './types.js';
import { createContext, type Dispatch, type SetStateAction } from 'react';

export type GlobalModalContextValue = {
  activeModalId: null | string;
  activeModalName: ModalTemplateKeys | null;
  closeModal: () => void;
  isOpen: boolean;
  openModal: () => void;
  setActiveModalId: Dispatch<SetStateAction<null | string>>;
  setActiveModalName: Dispatch<SetStateAction<ModalTemplateKeys | null>>;
  setActiveModalProps: Dispatch<SetStateAction<ModalArgs>>;
};

export const GlobalModalContext = createContext<GlobalModalContextValue | null>(
  null,
);
